package fr.frux.core.common.config

import kotlinx.browser.window

/**
 * URL de l'API, posée par la page hôte avant le chargement du bundle :
 *
 * ```html
 * <script>window.fruxApiBaseUrl = "https://api.frux-app.fr";</script>
 * ```
 *
 * Même canal que la source de tuiles (`window.fruxMapStyleUrl`, cf. ADR 0002) et pour la même
 * raison : l'hébergeur choisit son backend sans reconstruire le bundle. Un bundle web est servi
 * tel quel par un CDN — y figer une URL à la compilation obligerait à un artefact par
 * environnement.
 *
 * Le repli sur `http://localhost:8080` ne vaut qu'en développement (`scripts/dev-web.sh` sert la
 * page sur 8081 et l'API tourne sur 8080). En production, il ne peut pas servir accidentellement :
 * une page en HTTPS qui appellerait `http://localhost` est bloquée par le navigateur en contenu
 * mixte. C'est bruyant, donc préférable à un défaut plausible qui masquerait l'oubli.
 */
private const val DEV_FALLBACK_BASE_URL = "http://localhost:8080"

actual fun apiBaseUrl(): String =
    (window.asDynamic().fruxApiBaseUrl as? String)?.takeIf { it.isNotBlank() }
        ?: DEV_FALLBACK_BASE_URL
